<div class="rd-widget rd-widget-no-height-restriction widgetNoTopBorder">
  <table class="widget-small cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody *ngIf="editMode">
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'siteArea'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.siteArea" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="0" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'thereofSurplusLand'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.thereofSurplusLand" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="0" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'surplusLandValueEuroPerQm'" [align]="'left'"></widget-label></td>
        <td colspan="6">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.surplusLandValueEuroPerQm" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="4" *ngIf="(widgetData.thereofSurplusLand || 0) == 0 || (widgetData.surplusLandValueEuroPerQm || 0) == 0"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.thereofSurplusLand || 0) != 0 && (widgetData.surplusLandValueEuroPerQm || 0) != 0"><widget-value [align]="'right'">{{( (widgetData.thereofSurplusLand * widgetData.surplusLandValueEuroPerQm) | rdLocalizedNumber:0 )}} {{currency}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'siteServicingId'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <kendo-dropdownlist [data]="reflists['ref_site_servicing']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.siteServicingId"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'siteLayoutId'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <kendo-dropdownlist [data]="reflists['ref_site_layout']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.siteLayoutId"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'soilContaminationId'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <kendo-dropdownlist [data]="reflists['ref_soil_contamination']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.soilContaminationId"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'buildingEncumbrancesId'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <kendo-dropdownlist [data]="reflists['ref_building_encumbrances']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.buildingEncumbrancesId"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'groundLeaseId'" [align]="'left'"></widget-label></td>
        <td colspan="10">
          <kendo-dropdownlist [data]="reflists['ref_hereditary_building_right']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.groundLeaseId"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'groundLeaseExpiry'" [align]="'left'"></widget-label></td>
        <td colspan="4">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl [(ngModel)]="widgetData.groundLeaseExpiry" (ngChange)="setDirtyFlag(true)" [isNullable]="true"></pollux-report-designer-date-field>
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="!editMode" class="viewModeTbody">
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'siteArea'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{(  (widgetData.siteArea || 0) | rdLocalizedNumber:0 )}} {{unitOfLength}}²</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'thereofSurplusLand'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{(  (widgetData.thereofSurplusLand || 0) | rdLocalizedNumber:0 )}} {{unitOfLength}}²</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'surplusLandValueEuroPerQm'" [align]="'left'"></widget-label></td>
        <td colspan="4"><widget-value [align]="'right'">{{(  (widgetData.surplusLandValueEuroPerQm || 0) | rdLocalizedNumber:0 )}} {{currency}}/{{unitOfLength}}²</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.thereofSurplusLand || 0) == 0 || (widgetData.surplusLandValueEuroPerQm || 0) == 0"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.thereofSurplusLand || 0) != 0 && (widgetData.surplusLandValueEuroPerQm || 0) != 0"><widget-value [align]="'right'">{{( (widgetData.thereofSurplusLand * widgetData.surplusLandValueEuroPerQm) | rdLocalizedNumber:0 )}} {{currency}}</widget-value></td>

      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'siteServicingId'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{( widgetData.siteServicingId | rdReflist: reflists['ref_site_servicing'])}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'siteLayoutId'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{( widgetData.siteLayoutId | rdReflist: reflists['ref_site_layout'])}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'soilContaminationId'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{( widgetData.soilContaminationId | rdReflist: reflists['ref_soil_contamination'])}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'buildingEncumbrancesId'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{( widgetData.buildingEncumbrancesId | rdReflist: reflists['ref_building_encumbrances'])}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'groundLeaseId'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{( widgetData.groundLeaseId | rdReflist: reflists['ref_hereditary_building_right'])}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'groundLeaseExpiry'" [align]="'left'"></widget-label></td>
        <td colspan="4" *ngIf="( !widgetData.groundLeaseExpiry || widgetData.groundLeaseExpiry === '01.01.1900' )"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td colspan="4" *ngIf="( widgetData.groundLeaseExpiry && widgetData.groundLeaseExpiry !== '01.01.1900' )"><widget-value [align]="'right'">{{( widgetData.groundLeaseExpiry | rdLocalizedDate )}}</widget-value></td>
      </tr>
    </tbody>
  </table>
</div>
